import { type PropsWithChildren } from 'react';

import cx from '@/lib/cx';

interface FormNoteProps extends PropsWithChildren {
  status?: 'default' | 'error' | 'warning' | 'success' | 'info' | 'disabled';
  className?: string;
}

const FormNote = ({ status = 'default', children, className }: FormNoteProps) => (
  <p
    className={cx(
      'text-sm',
      {
        'text-gray-600': status === 'default',
        'text-red-600': status === 'error',
        'text-yellow-600': status === 'warning',
        'text-green-500': status === 'success',
        'text-theme-primary': status === 'info',
        'text-gray-400': status === 'disabled',
      },
      className
    )}
    data-formnote-status={status}
  >
    {children}
  </p>
);

export default FormNote;
